<template>
	<div>
		<!-- 头部 PC -->
		<div class="headbox fcss" v-if="$route.path!='/shopCat'&&$route.path!='/shopSuss'&&$route.path!='/shopCar'&&$route.path!='/shopWlMsg'&&$route.path!='/shopAddr'&&$route.path!='/shopOrder'&&$route.path!='/shopMsg'&&$route.path!='/login' && $route.path!='/register' && $route.path!='/latestNews' && $route.path!='/newsDetail' && $route.path!='/userCenter'">
			<SiteHeader />
		</div>
		
		<!-- 内容 -->
		<div class="home_msg">
			<router-view />
		</div>
		
		<!-- 底部 -->
		<div class="headbox fcss" v-if="$route.path!='/login' && $route.path!='/register'">
			<SiteFooter />
		</div>
		
	</div>
</template>
<script>
import { login } from "/src/api/api.js"
import SiteHeader from '@/components/siteHeader.vue'
import SiteFooter from '@/components/siteFooter.vue'
export default {
	components:{SiteHeader,SiteFooter},
	data(){
		return {
			
		}
	},
	mounted() {
		
	},
	methods:{
		
	}
}
</script>
<style lang="scss">
body{
	background: #F7F2EC;
}
</style>
<style lang="scss" scoped>

</style>